import styled from "@emotion/styled";
import { Tabs, useMantineColorScheme } from "@mantine/core";

import { specifications } from "@/api/inspect/inspectSpecification/useSpecificationsQuery";
import { InspectSpecificationInform } from "@/features/inspect/components/inspectSpecification/inform/InspectSpecificationInform";
import { LeftSpace } from "@/features/standard/detail/LeftSpace";
import { RightSpace } from "@/features/standard/detail/RightSpace";
import { ItemsGet200ResponseRowsInnerRoutingsInner } from "@sizlcorp/sizl-api-document/dist/models";
import { useQuery } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { InspectCriteriaUpdateInform } from "../../inspectCriteria/inform/InspectCriterialUpdateInform";
import { InspectCriterialTable } from "../../inspectCriteria/table/InspectCriterialTable";

interface InspectSpecificationUpdateFormProps {
  data?: ItemsGet200ResponseRowsInnerRoutingsInner;
}

export const InspectSpecificationUpdateForm = (params: InspectSpecificationUpdateFormProps) => {
  const { data } = params;
  const { t } = useTranslation();
  const { colorScheme } = useMantineColorScheme();
  const { data: specification } = useQuery(
    specifications.get({
      query: {
        $and: [
          {
            itemCode: data?.itemCode,
          },
        ],
      },
    }),
  );

  return (
    <>
      <RoutingWrapper>
        <RoutingDetailFormContainer>
          <InspectSpecificationInform data={data} />
          <Tabs
            variant="outline"
            defaultValue="inspectCriteria"
            styles={(theme) => ({
              tab: {
                "&:not([data-active])": {
                  backgroundColor:
                    colorScheme === "dark" ? "var(--gray-9, #1e1e1e)" : theme.colors?.gray?.[0],
                },
              },
            })}
          >
            <Tabs.List>
              <LeftSpace />
              <Tabs.Tab value="inspectCriteria">{t("inspect.inspectSpecification")}</Tabs.Tab>
              <RightSpace />
            </Tabs.List>
            <Tabs.Panel value="inspectCriteria">
              {/* 일단 검사표준은 하나라고 가정함 */}
              <InspectCriteriaUpdateInform
                data={{
                  ...data,
                  criteria: specification?.data?.rows?.[0]?.criteria,
                  specificationId: specification?.data?.rows?.[0]?.id,
                }}
              />
              <InspectCriterialTable data={specification?.data.rows} />
            </Tabs.Panel>
          </Tabs>
        </RoutingDetailFormContainer>
      </RoutingWrapper>
    </>
  );
};

const InspectStandardInformWrapper = styled.div`
  padding: 16px 32px;
`;

const RoutingDetailFormContainer = styled.div`
  width: 75rem;
  padding-top: 60px;
`;

const RoutingWrapper = styled.div`
  padding: 10px 10px;
`;
